import { render, staticRenderFns } from "./UAvatar.vue?vue&type=template&id=21036fc0&scoped=true&"
import script from "./UAvatar.vue?vue&type=script&lang=js&"
export * from "./UAvatar.vue?vue&type=script&lang=js&"
import style0 from "./UAvatar.vue?vue&type=style&index=0&id=21036fc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21036fc0",
  null
  
)

export default component.exports